import { AppIcon, RawSVG } from 'core/components/icons/icon.type';

export const iconCheckBold: AppIcon = {
  svgData: '<svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.4182 8L10.4182 16L6.7818 12.3636" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' as RawSVG,
  name: 'check-bold',
};
